import { combineReducers } from 'redux';
import activityCreatePageReducer from './activity-create-page';
import examCreatePageReducer from './exam-create-page';
import flashcardReducer from './flashcard';
import historicPageReducer from './historic-page';
import realtimeDbReducer from './realtime-database';
import reloginReducer from './relogin-visible';

const combinedReducers = combineReducers({
  realtimeDb: realtimeDbReducer,
  reloginVisible: reloginReducer,
  activityCreatePage: activityCreatePageReducer,
  examCreatePage: examCreatePageReducer,
  flashcard: flashcardReducer,
  historicPage: historicPageReducer,
});

export default combinedReducers;
